/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  rotate?: number,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ArrowRightFatIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{ transform: `rotate(${typeof props.rotate === "number" ? props.rotate : 0}deg)` }}
  >
    <g>
      <polygon points="0.5 15.504 0.5 8.504 13.5 8.504 13.5 2.025 23.508 12 13.5 22.004 13.5 15.504" />
    </g>
  </svg>
);

export default ArrowRightFatIcon;
